// absolute imports
import { Tooltip } from '@mui/material';
import { darken } from '@mui/material/styles';
import { Link } from '@tanstack/react-router';
import { makeStyles } from 'tss-react/mui';

import { useQuery } from '@apollo/client';

// import icons
import { NotificationsActive as InvitedIcon } from '@mui/icons-material';

// relative imports
import { PENDING_LINK_QUERY } from '../../data/apollo/queries';
import { useAccountConfig } from '../providers/AccountConfigProvider';
import { useAccount } from '../providers/AccountProvider';
import { useLedgibleAuth } from '../providers/LedgibleAuthProvider';
import LedgibleButton from '../shared/custom-components/buttons/LedgibleButton';
import useDisplayConfig from '../shared/custom-hooks/useDisplayConfig';
import { getContextualAppPath } from '../shared/utilities/appUtilities';

const useStyles = makeStyles()((theme) => ({
  linkButton: {
    backgroundColor: theme.palette.success.dark,
    border: `1px solid ${theme.palette.success.dark}`,
    borderRadius: 2,
    boxShadow: theme.shadows[3],
    '&:hover': {
      backgroundColor: darken(theme.palette.success.dark, 0.1),
      border: `1px solid ${darken(theme.palette.success.dark)}`,
    },
  },
}));

const PendingCodeInviteButton = () => {
  const { classes } = useStyles();
  const match = window.location.pathname === '/settings/general';
  const { loadingAccountInfo, currentAccount } = useAccount();
  const { loadingAccountConfig } = useAccountConfig();
  const { user } = useLedgibleAuth();
  const { adminLabel } = useDisplayConfig();

  // check for pending peparer link invite
  const { data: { checkPendingLinkCodeInvite: pendingLinkData } = {} } =
    useQuery(PENDING_LINK_QUERY, {
      variables: {
        email: user && user.profile.email,
      },
      fetchPolicy: 'cache-and-network',
      skip:
        !currentAccount.id ||
        loadingAccountInfo ||
        loadingAccountConfig ||
        currentAccount?.preparerLink?.clientActive ||
        match,
    });

  return !match && pendingLinkData?.hasPendingLink ? (
    <Tooltip
      title={`A ${adminLabel} has invited you to connect, click to view.`}
      placement="bottom-start"
      enterDelay={500}
      enterTouchDelay={500}
    >
      <span>
        <LedgibleButton
          component={Link}
          to={getContextualAppPath(`/settings/general`)}
          size="small"
          color="success"
          variant="contained"
          startIcon={<InvitedIcon fontSize="large" />}
          id="tax-pro-view-invite-button"
          className={classes.linkButton}
          marginRight={20}
        >
          {adminLabel} Invite
        </LedgibleButton>
      </span>
    </Tooltip>
  ) : null;
};

export default PendingCodeInviteButton;
